export function printfError(error: any) {
  console.error('(HISTORY) error', error);
}
